export default __webpack_public_path__ + "static/media/004-A-notaire.eadee8a5.png";